import React from 'react';

import styled from 'styled-components';

import useFormattedTldNavLinkMetadata from '~/builder/utils/useFormattedTldNavLinkMetadata';
import { CountryMenu as BaseCountryMenu } from '~/techstyle-shared/react-components';

const StyledCountryMenu = styled(BaseCountryMenu)`
  [data-country-menu] {
    background: none;
    z-index: 11;
  }

  [data-country-menu-list] {
    margin-top: 9px;
    margin-right: 5px;
    display: block;
    min-width: 180px;
  }

  [data-menu-item] {
    ${({ theme }) => theme.builderHeader.countryMenuItem};

    font-size: 14px;
    background-color: ${({ theme }) => theme.colors.palette.white};
    padding: 10px 14px;
    color: ${({ theme }) => theme.colors.textDefault};
  }

  [data-country-menu-icon] {
    height: 15px;
    width: 21px;
  }
`;

function BuilderCountryDropdown() {
  const formattedTldNavLinkMetadata = useFormattedTldNavLinkMetadata();

  return (
    <StyledCountryMenu
      placement="bottom-end"
      data-builder-component-type="country_dropdown"
      countries={formattedTldNavLinkMetadata.countries ?? []}
      value={formattedTldNavLinkMetadata.value}
    />
  );
}

export default BuilderCountryDropdown;
